import { mdiHeart, mdiHeartOutline } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '.'

const FriendIcon = (props: IconProps) => {
    const { filled = false, size = 1, ...other } = props
    return (
        <Icon
            data-testid="IconButton__AddFriend"
            path={filled ? mdiHeart : mdiHeartOutline}
            size={size}
            {...other}
        />
    )
}

export default FriendIcon
